// Single source of truth for non-engineers: edit colors, emails, launch date,
// social URLs and photo uploads here. Nothing else in the codebase needs touching.

export const site = {
  name: "Emmanuel Quezada",
  role: "Founder & Chief Executive Officer",
  company: "U-TOPIA, Inc.",
  location: "Bangkok · built in Dubai",
  recognition: "Forbes 30 Under 30 Mexico",
  born: "3 March 1997",
  launchDate: "16 October 2026",
  launchCity: "Bangkok",
  dates: {
    ucenterSoft: "May 2026",
    ucenterHard: "7 September 2026",
    summit: "Bangkok Summit · 15-16 October 2026",
    publicLaunch: "16 October 2026",
  },

  colors: {
    navy: "#0F1729",
    navyLift: "#152036",
    white: "#FFFFFF",
    orange: "#F7732D",
    orangeLight: "#FFA95D",
    neutral1: "#D8D8D8",
    neutral2: "#EFEFEF",
    neutral3: "#F7F7F7",
  },

  emails: {
    primary: "emmanuel@u-topia.com",
    press: "press@u-topia.com",
  },

  links: {
    utopia: "https://www.u-topia.com/",
    ucenter: "https://u.center/",
    linkedin: "https://ae.linkedin.com/in/emmanuel-quezada/en",
  },

  // To publish a photo: drop the file in /public/uploads/ and set src, e.g. "/uploads/hero.jpg".
  // Until then each slot renders its labeled navy placeholder.
  // fit: "cover" (default) fills the frame; "contain" shows the whole graphic on `bg`.
  images: {
    IMG_HERO: {
      src: "/uploads/hero-pay.webp",
      alt: "Emmanuel Quezada, Founder and CEO of u-topia, making a tap-to-pay transaction.",
      caption: "First transactions · tap to pay",
      note: "4:5",
    },
    IMG_ABOUT: {
      src: "/uploads/about.webp",
      alt: "Emmanuel Quezada speaking on stage at a u-topia event.",
      caption: "On stage · community room session",
      note: "4:5",
    },
    IMG_GALLERY_1: {
      src: "/uploads/room.webp",
      alt: "Emmanuel Quezada with a u-topia community room.",
      caption: "Community room · world tour",
      note: "1:1 or 4:5",
    },
    IMG_GALLERY_2: {
      src: "/uploads/forbes.webp",
      alt: "Forbes 30 Under 30 feature graphic for Emmanuel Quezada, u-topia Ecosystem.",
      caption: "Forbes 30 Under 30 feature",
      note: "Graphic · shown uncropped",
      fit: "contain",
      bg: "#FFFFFF",
    },
    IMG_GALLERY_3: {
      src: "/uploads/mic.webp",
      alt: "Emmanuel Quezada speaking at a u-topia community room.",
      caption: "Community room · mic in hand",
      note: "1:1 or 4:5",
    },
    IMG_OG: {
      src: "/uploads/og-face.jpg",
      alt: "Emmanuel Quezada, Founder and CEO of u-topia.",
      caption: "Open Graph image · square face crop",
      note: "Referenced by the og:image meta tag",
    },
  },
};
